module.exports = __webpack_public_path__ + "img/engraving-2@2x.f7c3b94.png";